import styled from "styled-components";
import { Wrapper } from '../Flexbox/Flexbox.styles'

export const Container = styled(Wrapper)`
background: #121212;
height: 100%;
min-height: 100vh;
align-items: start;
justify-content: start;
padding: 20px 50px 50px;
width: 100%;
flex-direction: column;
.roundedTile{
    border-radius: 5px;
}

.subhead{
    color: var(--purpleGrey);
}
h2{
    color: grey;
}
.songdetails h1{
    font-weight: 300;
    font-size: 1.3rem;
}
`;

export const InnerContainer = styled(Wrapper)`
/* background: #1c1c1c; */
height: 100%;
align-items: start;
max-width: 1300px;
`;

export const EmailLink = styled.a`
all: unset;
cursor: pointer;
color: var(--yellow);
font-weight: bold;
`;